import ABCyaPhaser from "@abcya/abcya_phaser";
import TextUtils from "@abcya/abcya_phaser/src/js/Utils/GameObjects/UI/TextUtils";
import Phaser from "phaser";
import FontKeys from "../FontKeys";
import gameData from "../gameData";
import SoundAssetKeys from "../SoundAssetKeys";
import SoundController from "../SoundController";
import UIAssetKeys from "../UIAssetKeys";

export const NavEvents = {
  RESET_SELECTED: "resetSelected",
  HOME_SELECTED: "homeSelected",
  HELP_SELECTED: "helpSelected",
};

export default class NavBar extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    this.bg = null;
    this.captures = null;
    this.sndBtnCont = null;
    this.menuBtn = null;
    this.muteBtn = null;
    this.soundBtn = null;
    this.levelTxt = null;
    this.totalLevelsTxt = null;
    this.levelLbl = null;
    this.levels = 0;
    this.emitter = new Phaser.Events.EventEmitter();

    this.background = ABCyaPhaser.Images.addImage(
      -8,
      0,
      UIAssetKeys._UIBarTop,
      this
    );
    this.background.setOrigin(0, 0);
  }

  enableResetButton() {
    if (this.resetButton) {
      this.resetButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => {
        this.emitter.emit(NavEvents.RESET_SELECTED);
      });
      this.resetButton.setInteractive({ cursor: "pointer" });
    }
  }

  enableHelpButton() {
    if (this.helpButton) {
      this.helpButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => {
        this.emitter.emit(NavEvents.HELP_SELECTED);
      });
      this.helpButton.setInteractive({ cursor: "pointer" });
    }
  }

  enableGameButtons() {
    this.menuButton = ABCyaPhaser.Images.addImage(
      -14,
      -10,
      UIAssetKeys._MenuBtn,
      this
    );
    this.menuButton.setOrigin(0, 0);

    this.muteButton = ABCyaPhaser.Images.addImage(
      this.scene.scale.width - 150,
      -10,
      UIAssetKeys._MuteBtn,
      this
    );
    this.muteButton.setOrigin(0, 0);

    this.soundButton = ABCyaPhaser.Images.addImage(
      this.scene.scale.width - 150,
      -10,
      UIAssetKeys._UnmuteBtn,
      this
    );
    this.soundButton.setOrigin(0, 0);
    this.soundButton.setVisible(false);

    this.setMuteState(gameData.isMuted);

    this.resetButton = ABCyaPhaser.Images.addImage(
      95,
      14,
      UIAssetKeys._ResetBtn,
      this
    );
    this.resetButton.setOrigin(0, 0);

    this.helpButton = ABCyaPhaser.Images.addImage(
      this.scene.scale.width - 280,
      14,
      UIAssetKeys._HelpBtn,
      this
    );
    this.helpButton.setOrigin(0, 0);

    const bar1 = ABCyaPhaser.Images.addImage(
      246,
      40,
      UIAssetKeys._UIBarTrapezoid,
      this
    );
    bar1.setOrigin(0, 0);

    const bar2 = ABCyaPhaser.Images.addImage(
      this.scene.scale.width - 350,
      40,
      UIAssetKeys._UIBarTrapezoid,
      this
    );
    bar2.setOrigin(0, 0);
  }

  enableLevelText(showLevelLabel) {
    this.centerBar = ABCyaPhaser.Images.addImage(
      this.scene.scale.width * 0.5,
      60,
      UIAssetKeys._UIBarCenterpiece,
      this
    );

    this.levelText = TextUtils.addText(
      this.scene.scale.width * 0.5 - 8,
      58,
      48,
      0x1df4ff,
      FontKeys._nulshockbold,
      "0",
      this,
      true
    );

    this.totalLevelsText = TextUtils.addText(
      this.scene.scale.width * 0.5 + 55,
      60,
      24,
      0x1df4ff,
      FontKeys._nulshockbold,
      "/0",
      this,
      true
    );

    if (showLevelLabel) {
      this.levelLabel = TextUtils.addText(
        this.scene.scale.width * 0.5 - 85,
        58,
        18,
        0x1df4ff,
        FontKeys._nokiolight,
        ABCyaPhaser.Localization.instance.getLocalizedString("level_selection_screen.level_header"),
        this,
        true
      );
    }
  }

  setLevelText(current, total) {
    if (this.levelText) {
      this.levelText.text = current;
      this.totalLevelsText.text = "/" + total;
    }
  }

  enableSoundButton() {
    this.muteButton.on(
      Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,
      this.toggleSound,
      this
    );
    this.muteButton.setInteractive({ cursor: "pointer" });

    this.soundButton.on(
      Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,
      this.toggleSound,
      this
    );
    this.soundButton.setInteractive({ cursor: "pointer" });
  }

  disable() {
    this.disableSoundButton();
    this.disableMenuButton();
    this.disableResetButton();
    this.disableHelpButton();
  }

  disableSoundButton() {
    if (this.soundContainer) {
      this.soundContainer.removeAllListeners();
    }
  }

  disableMenuButton() {
    if (this.menuButton) {
      this.menuButton.removeAllListeners();
    }
  }

  disableResetButton() {
    if (this.resetButton) {
      this.resetButton.removeAllListeners();
    }
  }

  disableHelpButton() {
    if (this.helpButton) {
      this.helpButton.removeAllListeners();
    }
  }

  toggleSound(event) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Click, this.scene);
    gameData.isMuted = !gameData.isMuted;
    this.setMuteState(gameData.isMuted);
  }

  setMuteState(isMuted) {
    if (isMuted) {
      this.muteButton.setVisible(true);
      this.soundButton.setVisible(false);
    } else {
      this.muteButton.setVisible(false);
      this.soundButton.setVisible(true);
    }
    SoundController.refreshMuteState(this.scene);
  }

  enableMenuButton() {
    this.menuButton.on(
      Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,
      () => {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Click, this.scene);
        this.emitter.emit(NavEvents.HOME_SELECTED);
      },
      this
    );
    this.menuButton.setInteractive({ cursor: "pointer" });
  }
}
